// extracted by css-extract-rspack-plugin
export default {"root":"W9CGQa","no-prompts":"_ssGhd","noPrompts":"_ssGhd","core-icon":"nv9WVT","coreIcon":"nv9WVT","upsell":"KXqifQ"};